module.exports = __webpack_public_path__ + "static/media/atrium-3.6b9a0e9c.jpg";